import { render } from "./DriverList.vue?vue&type=template&id=5fcbb22a&scoped=true"
import script from "./DriverList.vue?vue&type=script&lang=js"
export * from "./DriverList.vue?vue&type=script&lang=js"

import "./DriverList.vue?vue&type=style&index=0&id=5fcbb22a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcbb22a"]])

export default __exports__